import React from 'react';
import './Header.css';

/**
 * Header Component
 * Main navigation header with logo and history button
 */
function Header({ onHistoryClick }) {
  const handleLogoClick = () => {
    // Redirect to index/home page
    window.location.href = '/';
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo Section - Left */}
        <div className="header-logo-section">
          <button
            className="header-logo-button"
            onClick={handleLogoClick}
            aria-label="Go to home page"
          >
            <img
              src="/assets/logones.png"
              alt="NES Group Logo"
              className="header-logo"
            />
          </button>
        </div>

        {/* History Button - Right */}
        <div className="header-actions">
          <button
            className="header-history-button"
            onClick={onHistoryClick}
            aria-label="View search history"
          >
            <img
              src="/assets/icon_clock.png"
              alt="History"
              className="header-history-icon"
            />
            <span className="header-history-text">History</span>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
